import { useEffect, useState } from "react";
import { getRoleById } from "../services/roleService";

interface IUseFetchRoleById {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  roleId: string | null;
}

const useFetchRoleById = ({ setIsLoading, roleId }: IUseFetchRoleById) => {
  const [roleData, setRoleData] = useState<any>(null);

  useEffect(() => {
    if (!roleId) {
      setRoleData(null);
      return;
    }

    setIsLoading(true);
    const getRoleData = async () => {
      try {
        const res = await getRoleById(roleId);
        setRoleData(res);
      } catch (err) {
        setRoleData(null);
      } finally {
        setIsLoading(false);
      }
    };
    getRoleData();
  }, [setIsLoading, roleId]);

  return [roleData];
};

export default useFetchRoleById;
